import React from 'react';

import Button from '@amzn/meridian/button';
import Row, { type RowProps } from '@amzn/meridian/row/row';
import DebounceSearchField from 'src/components/shared/debounceSearchField/debounceSearchField';
import {
  setIsTaskGroupModalOpen,
  setTaskGroupSearchFieldValue,
} from 'src/store/adminConfigPageSlice/taskConfigPageSlice/taskConfigPageSlice';
import { useAppDispatch, useAppSelector } from 'src/store/store';

// **** Components **** //

/**
 * Default component
 */
const TopOptions = (props: RowProps) => {
  const dispatch = useAppDispatch();
  const { taskGroupSearchFieldValue } = useAppSelector((state) => state.taskConfigPage);

  return (
    <Row alignmentHorizontal="justify" {...props}>
      <Row>
        <DebounceSearchField
          value={taskGroupSearchFieldValue}
          onDebounce={(v) => dispatch(setTaskGroupSearchFieldValue(v))}
          placeholder="Search for..."
        />
      </Row>
      <Row>
        <Button onClick={() => dispatch(setIsTaskGroupModalOpen(true))}>Add Group</Button>
      </Row>
    </Row>
  );
};

// **** Export **** //

export default TopOptions;
